/* Hızlı beden seçimi | 360 Koruma
   Kartlardaki "Sepete Ekle" (.js-btn-quickview) temanın büyük modalı yerine bu pencereyi açar. */
(function () {
  if (window.__hsInit) return;
  window.__hsInit = true;

  var C = window.HIZLI_SECIM || {};
  var MAX_QTY = 999;
  var cache = {};
  var ui = null;          // pencere DOM'u
  var st = null;          // açık ürünün durumu
  var lastFocus = null;

  /* ---------- yardımcılar ---------- */
  function pad2(n) { return n < 10 ? '0' + n : '' + n; }
  function group(s, sep) { return s.replace(/(\d)(?=(\d{3})+$)/g, '$1' + sep); }
  function money(cents) {
    var f = (C.moneyFormat || '{{amount_with_comma_separator}} TL').replace(/<[^>]*>/g, '');
    var key = (f.match(/amount[a-z_]*/) || ['amount'])[0];
    var n = Math.round(cents), lira = Math.floor(n / 100), kurus = n % 100, v;
    if (key === 'amount_no_decimals') v = group(String(Math.round(n / 100)), ',');
    else if (key === 'amount_with_comma_separator') v = group(String(lira), '.') + ',' + pad2(kurus);
    else if (key === 'amount_no_decimals_with_comma_separator') v = group(String(Math.round(n / 100)), '.');
    else if (key === 'amount_with_apostrophe_separator') v = group(String(lira), "'") + '.' + pad2(kurus);
    else v = group(String(lira), ',') + '.' + pad2(kurus);
    return f.replace(/\{\{[^}]*\}\}/, v);
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function esc(s) { return String(s == null ? '' : s); }
  function imgUrl(src, w) {
    if (!src) return '';
    var u = src.indexOf('//') === 0 ? 'https:' + src : src;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function isMobile() { return window.matchMedia('(max-width: 767px)').matches; }

  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    var base = (C.root || '/').replace(/\/$/, '');
    return fetch(base + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) { cache[handle] = p; return p; });
  }

  /* ---------- pencere iskeleti ---------- */
  function build() {
    if (ui) return ui;
    var root = el('div', 'hs-root');
    root.hidden = true;
    var backdrop = el('div', 'hs-backdrop');
    var sheet = el('section', 'hs-sheet');
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-labelledby', 'hs-title');
    sheet.tabIndex = -1;

    var grip = el('div', 'hs-grip'); grip.setAttribute('aria-hidden', 'true');

    var head = el('div', 'hs-head');
    var thumb = el('div', 'hs-thumb');
    var img = el('img'); img.alt = ''; img.width = 88; img.height = 88; img.loading = 'lazy';
    thumb.appendChild(img);
    var meta = el('div', 'hs-meta');
    var vendor = el('div', 'hs-vendor');
    var title = el('h2', 'hs-title'); title.id = 'hs-title';
    var price = el('div', 'hs-price');
    meta.appendChild(vendor); meta.appendChild(title); meta.appendChild(price);
    var close = el('button', 'hs-close');
    close.type = 'button';
    close.setAttribute('aria-label', 'Kapat');
    close.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';
    head.appendChild(thumb); head.appendChild(meta); head.appendChild(close);

    var body = el('div', 'hs-body');
    var foot = el('a', 'hs-pdp', 'Ürün sayfasına git');

    sheet.appendChild(grip); sheet.appendChild(head); sheet.appendChild(el('div', 'hs-sep')); sheet.appendChild(body); sheet.appendChild(foot);
    root.appendChild(backdrop); root.appendChild(sheet);
    document.body.appendChild(root);

    backdrop.addEventListener('click', closeSheet);
    close.addEventListener('click', closeSheet);
    root.addEventListener('keydown', onKey);

    ui = { root: root, sheet: sheet, backdrop: backdrop, img: img, vendor: vendor, title: title, price: price, body: body, foot: foot, close: close };
    enableSwipe();
    return ui;
  }

  // Mobil: paneli aşağı kaydırarak kapat (panelin her yerinden ve arka plandan)
  function enableSwipe() {
    var root = ui.root, sheet = ui.sheet, backdrop = ui.backdrop;
    var tracking = false, dragging = false, alwaysDrag = false;
    var startY = 0, lastY = 0, dy = 0, t0 = 0;
    function reset() {
      sheet.style.transition = '';
      sheet.style.transform = '';
      backdrop.style.transition = '';
      backdrop.style.opacity = '';
    }
    function beginDrag(y) { dragging = true; startY = y; t0 = Date.now(); }
    root.addEventListener('touchstart', function (e) {
      if (!root.classList.contains('hs-mobile') || e.touches.length !== 1) return;
      var t = e.target;
      if (t.closest && t.closest('input, textarea')) return;
      tracking = true; dragging = false; dy = 0;
      lastY = e.touches[0].clientY;
      // Üst kısım (tutamaç, görsel, başlık) ve arka plan: içerik kaydırmadan doğrudan sürükle
      alwaysDrag = !!(t.closest && (t.closest('.hs-grip, .hs-head') || t === backdrop));
      if (alwaysDrag || sheet.scrollTop <= 0) beginDrag(lastY);
    }, { passive: true });
    root.addEventListener('touchmove', function (e) {
      if (!tracking) return;
      var y = e.touches[0].clientY;
      // İçerik kaydırılmışsa: en üste gelince aynı hareketle sürüklemeye geç
      if (!dragging) {
        if (sheet.scrollTop <= 0 && y > lastY) beginDrag(y);
        lastY = y;
        if (!dragging) return;
      }
      dy = y - startY;
      if (dy <= 0) {
        if (sheet.style.transform) reset();
        if (dy < 0) {
          // Yukarı hareket: içerik varsa kaysın (sürüklemeyi bırak, tekrar aşağı inince yeniden başlar)
          if (!alwaysDrag) { dragging = false; lastY = y; }
          else if (e.cancelable) e.preventDefault();
        }
        return;
      }
      if (e.cancelable) e.preventDefault();
      sheet.style.transition = 'none';
      backdrop.style.transition = 'none';
      sheet.style.transform = 'translateY(' + dy + 'px)';
      backdrop.style.opacity = String(Math.max(0, 1 - dy / (sheet.offsetHeight || 400)));
    }, { passive: false });
    function end() {
      if (!tracking) return;
      tracking = false;
      var wasDragging = dragging;
      dragging = false;
      if (!wasDragging) { dy = 0; return; }
      var speed = dy / Math.max(1, Date.now() - t0); // px/ms
      var shouldClose = dy > Math.min(120, sheet.offsetHeight * 0.22) || (dy > 30 && speed > 0.5);
      reset();
      if (shouldClose) closeSheet();
      dy = 0;
    }
    root.addEventListener('touchend', end);
    root.addEventListener('touchcancel', end);
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
    if (e.key !== 'Tab') return;
    var f = ui.sheet.querySelectorAll('button:not([disabled]), a[href], [tabindex="0"]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function openSheet() {
    build();
    lastFocus = document.activeElement;
    syncMode();
    ui.root.hidden = false;
    document.documentElement.classList.add('hs-lock');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { ui.root.classList.add('is-open'); ui.sheet.focus({ preventScroll: true }); });
    });
  }

  function closeSheet() {
    if (!ui || ui.root.hidden) return;
    ui.root.classList.remove('is-open');
    document.documentElement.classList.remove('hs-lock');
    setTimeout(function () { ui.root.hidden = true; }, 220);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- fiyat ---------- */
  function renderPrice() {
    var v = currentVariant() || firstAvailable();
    var cents = v ? v.price : st.p.price;
    var compare = v ? v.compare_at_price : st.p.compare_at_price;
    var box = ui.price;
    box.innerHTML = '';
    if (st.sepette && C.sepetteOran > 0) {
      box.appendChild(el('span', 'hs-pill', '%' + C.sepetteOran));
      box.appendChild(el('s', 'hs-old', money(cents)));
      box.appendChild(el('span', 'hs-new', money(cents * (100 - C.sepetteOran) / 100)));
      box.appendChild(el('span', 'hs-note', 'Sepette indirimli fiyat'));
    } else if (compare && compare > cents) {
      box.appendChild(el('span', 'hs-pill', '%' + Math.round((1 - cents / compare) * 100)));
      box.appendChild(el('s', 'hs-old', money(compare)));
      box.appendChild(el('span', 'hs-new', money(cents)));
    } else {
      box.appendChild(el('span', 'hs-regular', money(cents)));
    }
  }

  /* ---------- varyant mantığı ---------- */
  function variants() { return st.p.variants || []; }
  function firstAvailable() { return variants().filter(function (v) { return v.available; })[0] || variants()[0]; }
  function currentVariant() {
    var sel = st.sel;
    for (var i = 0; i < sel.length; i++) if (sel[i] == null) return null;
    return variants().filter(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    })[0] || null;
  }
  // Bu değer, diğer seçimlerle birlikte stokta olan bir varyant veriyor mu?
  function valueAvailable(optIndex, value) {
    return variants().some(function (v) {
      if (!v.available || v.options[optIndex] !== value) return false;
      return v.options.every(function (o, i) { return i === optIndex || st.sel[i] == null || st.sel[i] === o; });
    });
  }

  /* ---------- gövde ---------- */
  function renderBody() {
    var b = ui.body;
    b.innerHTML = '';
    if (st.added) { renderAdded(b); return; }

    var single = st.p.variants.length === 1 && /default title/i.test(st.p.variants[0].title);
    if (!single) {
      st.p.options.forEach(function (opt, oi) {
        var name = typeof opt === 'string' ? opt : opt.name;
        var values = (typeof opt === 'string' ? null : opt.values) || uniqueValues(oi);
        var group = el('div', 'hs-group');
        var lab = el('div', 'hs-label');
        lab.appendChild(document.createTextNode(name + ' seçin'));
        if (st.sel[oi] != null) {
          var chosen = el('span', 'hs-chosen', ': ' + st.sel[oi]);
          lab.appendChild(chosen);
        }
        lab.id = 'hs-lab-' + oi;
        group.appendChild(lab);
        var grid = el('div', 'hs-grid' + (values.length > 8 || values.every(function (v) { return String(v).length <= 4; }) ? ' hs-grid--sm' : ''));
        grid.setAttribute('role', 'radiogroup');
        grid.setAttribute('aria-labelledby', lab.id);
        values.forEach(function (val) {
          var ok = valueAvailable(oi, val);
          var btn = el('button', 'hs-opt', val);
          btn.type = 'button';
          btn.setAttribute('role', 'radio');
          var on = st.sel[oi] === val;
          btn.setAttribute('aria-checked', on ? 'true' : 'false');
          if (on) btn.classList.add('is-on');
          if (!ok) {
            btn.classList.add('is-out');
            btn.setAttribute('aria-disabled', 'true');
            btn.setAttribute('aria-label', val + ', stokta yok');
          }
          btn.addEventListener('click', function () {
            if (!ok) return;
            st.sel[oi] = val;
            st.error = '';
            render();
            var again = ui.body.querySelectorAll('.hs-group')[oi];
            var focusBtn = again && again.querySelector('.hs-opt.is-on');
            if (focusBtn) focusBtn.focus({ preventScroll: true });
          });
          grid.appendChild(btn);
        });
        group.appendChild(grid);
        b.appendChild(group);
      });
      var anyOut = st.p.variants.some(function (v) { return !v.available; });
      if (anyOut) b.appendChild(el('p', 'hs-help', 'Üstü çizili seçenekler şu an stokta yok.'));
    }

    var v = single ? st.p.variants[0] : currentVariant();
    var row = el('div', 'hs-actions');
    var qty = el('div', 'hs-qty');
    qty.setAttribute('role', 'group');
    qty.setAttribute('aria-label', 'Adet');
    var minus = el('button', 'hs-qty__btn', '−'); minus.type = 'button'; minus.setAttribute('aria-label', 'Adedi azalt');
    var input = el('input', 'hs-qty__val');
    input.type = 'number'; input.min = '1'; input.max = String(MAX_QTY); input.inputMode = 'numeric';
    input.value = String(st.qty); input.setAttribute('aria-label', 'Adet');
    var plus = el('button', 'hs-qty__btn', '+'); plus.type = 'button'; plus.setAttribute('aria-label', 'Adedi artır');
    minus.disabled = st.qty <= 1;
    minus.addEventListener('click', function () { st.qty = Math.max(1, st.qty - 1); input.value = st.qty; minus.disabled = st.qty <= 1; });
    plus.addEventListener('click', function () { st.qty = Math.min(MAX_QTY, st.qty + 1); input.value = st.qty; minus.disabled = st.qty <= 1; });
    input.addEventListener('change', function () {
      var n = parseInt(input.value, 10);
      st.qty = isNaN(n) ? 1 : Math.min(MAX_QTY, Math.max(1, n));
      input.value = st.qty; minus.disabled = st.qty <= 1;
    });
    qty.appendChild(minus); qty.appendChild(input); qty.appendChild(plus);

    var add = el('button', 'hs-add');
    add.type = 'button';
    var missing = !v;
    var soldOut = v && !v.available;
    if (st.busy) { add.textContent = 'Ekleniyor…'; add.disabled = true; }
    else if (missing) { add.textContent = firstMissingName() + ' seçin'; add.disabled = true; }
    else if (soldOut) { add.textContent = 'Tükendi'; add.disabled = true; }
    else { add.textContent = 'Sepete ekle'; }
    add.addEventListener('click', function () { if (v && v.available) addToCart(v); });
    row.appendChild(qty); row.appendChild(add);
    b.appendChild(row);

    if (st.error) {
      var err = el('p', 'hs-error', st.error);
      err.setAttribute('role', 'alert');
      b.appendChild(err);
    }
  }

  function uniqueValues(oi) {
    var seen = [];
    variants().forEach(function (v) { if (seen.indexOf(v.options[oi]) === -1) seen.push(v.options[oi]); });
    return seen;
  }

  function firstMissingName() {
    for (var i = 0; i < st.sel.length; i++) {
      if (st.sel[i] == null) {
        var o = st.p.options[i];
        return typeof o === 'string' ? o : o.name;
      }
    }
    return 'Seçenek';
  }

  function renderAdded(b) {
    var ok = el('div', 'hs-ok');
    ok.setAttribute('role', 'status');
    ok.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#E95A25"/><path d="M7 12.5l3.2 3.2L17 9" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var t = el('div');
    var strong = el('strong', null, st.addedQty + ' adet' + (st.addedLabel ? ', ' + st.addedLabel : ''));
    t.appendChild(strong);
    t.appendChild(document.createTextNode(' sepete eklendi'));
    ok.appendChild(t);
    b.appendChild(ok);

    var row = el('div', 'hs-after');
    var more = el('button', 'hs-btn-outline', 'Başka seçenek ekle');
    more.type = 'button';
    if (st.p.variants.length === 1) more.textContent = 'Alışverişe devam et';
    more.addEventListener('click', function () {
      if (st.p.variants.length === 1) { closeSheet(); return; }
      st.added = false; st.qty = 1; st.sel = st.sel.map(function () { return null; });
      autoSelect(); render();
    });
    var go = el('a', 'hs-btn-primary', 'Sepete git');
    go.href = C.cartUrl || '/cart';
    go.addEventListener('click', function (e) {
      var drawer = document.querySelector('.js-mini-cart.cardraw');
      if (drawer) { e.preventDefault(); closeSheet(); setTimeout(function () { drawer.classList.add('active'); }, 230); }
    });
    row.appendChild(more); row.appendChild(go);
    b.appendChild(row);
    setTimeout(function () { go.focus({ preventScroll: true }); }, 30);
  }

  function render() { renderPrice(); renderBody(); }

  // Tek değerli seçenekleri otomatik seç (ör. tek renk)
  function autoSelect() {
    st.p.options.forEach(function (opt, oi) {
      var vals = (typeof opt === 'string' ? null : opt.values) || uniqueValues(oi);
      if (vals.length === 1) st.sel[oi] = vals[0];
    });
  }

  /* ---------- sepete ekleme ---------- */
  function addToCart(v) {
    st.busy = true; st.error = ''; renderBody();
    var base = (C.root || '/').replace(/\/$/, '');
    fetch(base + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: v.id, quantity: st.qty }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        st.busy = false;
        if (!res.ok) {
          st.error = (res.d && (res.d.description || res.d.message)) || 'Ürün sepete eklenemedi. Lütfen tekrar deneyin.';
          renderBody();
          return;
        }
        st.added = true;
        st.addedQty = st.qty;
        st.addedLabel = /default title/i.test(v.title) ? '' : v.title.replace(/ \/ /g, ', ') + (st.p.options.length === 1 && /numara/i.test(optName(0)) ? ' numara' : '');
        renderBody();
        refreshCart();
      })
      .catch(function () {
        st.busy = false;
        st.error = 'Bağlantı hatası. Lütfen tekrar deneyin.';
        renderBody();
      });
  }

  function optName(i) { var o = st.p.options[i]; return typeof o === 'string' ? o : (o && o.name) || ''; }

  function refreshCart() {
    // Tema sepeti yenilerken çekmeceyi kendiliğinden açıyor; onay penceresi açıkken kapalı tut
    var drawer = document.querySelector('.js-mini-cart.cardraw');
    var wasActive = drawer && drawer.classList.contains('active');
    if (drawer && !wasActive) {
      [0, 150, 400, 900].forEach(function (ms) {
        setTimeout(function () {
          if (ui && !ui.root.hidden && drawer.classList.contains('active')) drawer.classList.remove('active');
        }, ms);
      });
    }
    try {
      if (window.theme && theme.miniCart) {
        if (typeof theme.miniCart.generateCart === 'function') theme.miniCart.generateCart();
        if (typeof theme.miniCart.updateElements === 'function') theme.miniCart.updateElements();
      }
    } catch (e) {}
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.js-cart-count').forEach(function (n) { n.textContent = c.item_count; });
    }).catch(function () {});
  }

  /* ---------- açılış ---------- */
  function openFor(btn) {
    var handle = btn.getAttribute('data-handle');
    if (!handle) return false;
    var card = btn.closest('[data-price], .js-product-card, .product-card');
    var sepette = !!(card && card.querySelector('.sepette-uygun-isaret'));
    btn.classList.add('hs-loading');
    fetchProduct(handle).then(function (p) {
      btn.classList.remove('hs-loading');
      build();
      st = { p: p, sel: p.options.map(function () { return null; }), qty: 1, added: false, busy: false, error: '', sepette: sepette };
      autoSelect();
      var src = p.featured_image || (p.images && p.images[0]);
      ui.img.src = imgUrl(src, 200);
      ui.img.style.visibility = src ? '' : 'hidden';
      ui.vendor.textContent = esc(p.vendor);
      ui.title.textContent = esc(p.title);
      ui.foot.href = p.url || ('/products/' + handle);
      render();
      openSheet();
    }).catch(function () {
      btn.classList.remove('hs-loading');
      // Veri alınamazsa ürün sayfasına git
      window.location.href = '/products/' + handle;
    });
    return true;
  }

  // Temanın modalından önce yakala (window, yakalama aşaması)
  function onTrigger(e) {
    var btn = e.target.closest && e.target.closest('.js-btn-quickview');
    if (!btn || !btn.getAttribute('data-handle')) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    openFor(btn);
  }
  window.addEventListener('click', onTrigger, true);
  window.addEventListener('keydown', onTrigger, true);

  // Ekran yönü/boyutu değişince sınıfı güncelle (alt panel ↔ pencere)
  function syncMode() { if (ui) ui.root.classList.toggle('hs-mobile', isMobile()); }
  window.addEventListener('resize', syncMode);
})();
